/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom/client';
import ReactDOMServer from 'react-dom/server';
import _ from 'underscore';

import EditPrimerTabState from 'analyses/EditPrimerTabState';
import PrimerWizardTabState from 'analyses/primers/PrimerWizardTabState';
import * as analytics from 'analytics/Analytics';
import asm from 'assembly/Asm';
import {assert} from 'Asserts';
import * as biojs from 'BioJS';
import {Model as BioJSSequencePrimer, Collection as BioJSSequencePrimers} from 'biojs/SequencePrimer';
import * as util from 'biojs/Util';
import {Selection, Sequence} from 'components/Sequence';
import {ANALYTICS_MODULE} from 'constants/AnalyticsConstants';
import {PrimerPreferences} from 'constants/PrimerConstants';
import {SequenceType} from 'constants/SequenceConstants';
import FileStates, {PrimerPanelState} from 'FileStates';
import {blastPrimer as openBlastForPrimer} from 'molbio/ExternalLib';
import {FindPrimersOptions} from 'molbio/find-primers/FindPrimersConstants';
import {FindPrimersTabState} from 'molbio/find-primers/FindPrimersTabState';
import MeltingTempModal from 'molbio/melting-temp/MeltingTempModal';
import SequencePrimer from 'molbio/primers/backbone/SequencePrimer';
import SequencePrimers from 'molbio/primers/backbone/SequencePrimers';
import {canCreatePrimerPair, createPrimerPair} from 'molbio/primers/PrimerUtil';
import ToolbarSignupMessage from 'nav/share/growth/ToolbarSignupMessage';
import {showValueMessagingForSharedFile} from 'nav/share/growth/Util';
import {TabState} from 'Navigation';
import notifications from 'notifications';
import preferences from 'Preferences';
import {renderToDOM, unmountRootsAsync} from 'redux-stores/ReduxDOMRender';
import LinksInformationTemplate from 'toolbar/primer-panel/LinksInformationTemplate';
import LinksRowTemplate from 'toolbar/primer-panel/LinksRowTemplate';
import PrimerInformationTemplate from 'toolbar/primer-panel/PrimerInformationTemplate';
import PrimerTable from 'toolbar/primer-panel/PrimerTable';
import {renderPanelTabs} from 'toolbar/shared/PanelUtil';
import {SEQUENCE_PRIMER_PANEL_PAIRS, SEQUENCE_PRIMER_PANEL_PRIMERS} from 'toolbar/ToolbarConstants';
import legacyRunModal from 'ui-library/legacyRunModal';
import runConfirmDeleteModal from 'ui-library/modals/runConfirmDeleteModal';

import {getPrimerTableProps} from './PrimerTablePropsHelpers';

class InsertBase extends Backbone.View<PrimerPanelState> {
  panelState!: PrimerPanelState;

  insert(tab: TabState): PrimerPanelState {
    // SequenceFileState._setupPrimerPanel installs buffers before this view is constructed.
    this.panelState.get('buffers')!.addTab(tab);
    return this.panelState.trigger('close');
  }
}

class PrimerInfoView extends InsertBase {
  sequence!: Sequence;
  selectedPrimer: SequencePrimer | undefined;
  template!: (allowFeatureEdits: boolean) => string;

  static initClass(): void {
    this.prototype.template = (allowFeatureEdits: boolean): string =>
      ReactDOMServer.renderToStaticMarkup(
        <PrimerInformationTemplate allowFeatureEdits={allowFeatureEdits} />
      );

    this.prototype.events = {
      // @ts-expect-error -- Vendored Backbone types model events as a function, but Backbone accepts a hash.
      'click .detach-primer': 'deleteActivePrimer',
      'click .adjust-tm': 'adjustMeltingTemperature',
      'click .secondary-analyze': 'analyzeSecondary',
      'click .other-binding': 'findOtherBinding',
      'click .edit-primer': 'editPrimer',
      'click .blast-primer': 'blastPrimer',
    };
  }

  deleteActivePrimer(): PrimerPanelState {
    return this.panelState.trigger('deleteActive');
  }

  findOtherBinding(): PrimerPanelState {
    FindPrimersTabState.insert(
      this.sequence,
      {findType: FindPrimersOptions.SINGLE},
      this.selectedPrimer!.get('_primer')
    );
    return this.panelState.trigger('close');
  }

  analyzeSecondary(): PrimerPanelState {
    EditPrimerTabState.edit(this.selectedPrimer!.get('_primer'), this.sequence, true);
    return this.panelState.trigger('close');
  }

  blastPrimer(): Window | null {
    return openBlastForPrimer(this.selectedPrimer!);
  }

  adjustMeltingTemperature(): void {
    legacyRunModal(MeltingTempModal, {});
  }

  editPrimer(): PrimerPanelState {
    EditPrimerTabState.edit(this.selectedPrimer!.get('_primer'), this.sequence);
    return this.panelState.trigger('close');
  }

  override render(): this {
    if (this.selectedPrimer == null || this.selectedPrimer.isNew()) {
      this.$el.hide();
      this.panelState.trigger('resize');
      return this;
    }
    this.$el.show();

    const bindingBases = this.selectedPrimer.bindingBases();

    this.$('.name').text(this.selectedPrimer.name());
    const _primer = this.selectedPrimer.get('_primer');
    if (_primer.get('folder') != null) {
      this.$('.library').click(() => {
        FileStates.get().openFolder(_primer.get('folder_api_id')!, _primer.get('folder_url'));
      });
      this.$('.library').text(`${_primer.get('owner')}/${_primer.get('folder')}`);
    } else {
      this.$('.library').text('None').addClass('disabled');
    }

    this.$('.sequence-primer-bases-inner').html(this.selectedPrimer.basesHtml(this.sequence));
    this.$('.length').text(this.selectedPrimer.bases().length);
    this.$('.gc').text(`${(util.gc(bindingBases, this.selectedPrimer.nucleotideType()) * 100).toFixed(1)}%`);
    this.$('.melting-temp').text(this.selectedPrimer.displayMeltingTemperature());

    const allowFeatureEdits = this.sequence.allowFeatureEdits() && this.selectedPrimer.editable();
    this.$('.edit-primer').toggleClass('hidden', !allowFeatureEdits);
    this.$('.js-detach').toggleClass(
      'hidden',
      !allowFeatureEdits ||
        _primer.get('folder_api_id') == null ||
        asm.of(this.sequence._sequence()).isFlankingPrimer(this.sequence._sequence(), this.selectedPrimer)
    );

    this.updateColor();
    this.panelState.trigger('resize');
    return this;
  }

  updatePrimerListeners(): void {
    if (this.selectedPrimer != null) {
      this.stopListening(this.selectedPrimer.get('_primer'));
    }
    this.selectedPrimer = this.sequence.sequencePrimers().findWhere({active: true});
    this.render();
    this.allowSpecificityCheck();
    if (this.selectedPrimer) {
      this.listenTo(
        this.selectedPrimer.get('_primer'),
        'change:bases',
        // eslint-disable-next-line no-restricted-syntax, @typescript-eslint/unbound-method -- _.bind supplies the receiver.
        _.bind(this.update, this, this.panelState, this.sequence)
      );
      this.listenTo(
        this.selectedPrimer.get('_primer'),
        'change:name',
        function (this: PrimerInfoView, _primer: BioJSSequencePrimer): JQuery {
          return this.$el.find('.name').text(_primer.get('name'));
        }
      );
      // eslint-disable-next-line @typescript-eslint/unbound-method -- Backbone listenTo supplies the receiver.
      this.listenTo(this.selectedPrimer.get('_primer'), 'change:color', this.updateColor);
      // eslint-disable-next-line @typescript-eslint/unbound-method -- Backbone listenTo supplies the receiver.
      this.listenTo(this.selectedPrimer.get('_primer'), 'change:nucleotideType', this.allowSpecificityCheck);
    }
  }

  updateColor(): JQuery {
    return this.$el
      .find('.swatch-big')
      .css('background-color', this.selectedPrimer!.color())
      .toggleClass('disabled', !this.sequence.allowFeatureEdits());
  }

  allowSpecificityCheck(): void {
    if (!this.sequence.get('currentVersion')) {
      this.$el.find('.other-binding').addClass('disabled').tooltip({
        placement: 'left',
        title: 'Specificity cannot be checked when on a historical version. (Feedback welcome.)',
      });
    } else {
      this.$el.find('.other-binding').removeClass('disabled').tooltip('destroy');
    }
  }

  update(panelState: PrimerPanelState, sequence: Sequence): this {
    if (this.panelState != null) {
      this.stopListening(this.panelState);
    }
    this.panelState = panelState;

    this.stopListening(preferences);
    this.listenTo(
      preferences,
      `change:${PrimerPreferences.MELTING_TEMP_DNA} change:${PrimerPreferences.MELTING_TEMP_RNA}`,
      // eslint-disable-next-line @typescript-eslint/unbound-method -- Backbone listenTo supplies the receiver.
      this.render
    );

    if (this.sequence != null) {
      this.stopListening(this.sequence);
    }
    this.sequence = sequence;
    // When reset, change:selected doesn't get hit so we need to check if selected primer has changed.
    // eslint-disable-next-line @typescript-eslint/unbound-method -- Backbone listenTo supplies the receiver.
    this.listenTo(this.sequence.sequencePrimers(), 'change:active reset', this.updatePrimerListeners);
    this.$el.html(this.template(this.sequence.allowFeatureEdits()));
    this.allowSpecificityCheck();
    // eslint-disable-next-line @typescript-eslint/unbound-method -- Backbone listenTo supplies the receiver.
    this.listenTo(this.sequence, 'change:currentVersion', this.allowSpecificityCheck);
    this.updatePrimerListeners();
    return this.render();
  }
}
PrimerInfoView.initClass();

interface LinksRowViewOptions extends Backbone.ViewOptions<Backbone.Model> {
  collection: SequencePrimers;
  sequence: Sequence;
}

class LinksRowView extends Backbone.View<Backbone.Model> {
  override collection!: SequencePrimers;
  override model!: biojs.PrimerPair;
  sequence!: Sequence;
  template!: typeof LinksRowTemplate;

  static initClass(): void {
    this.prototype.template = LinksRowTemplate;
    this.prototype.tagName = 'tbody';
    this.prototype.events = {
      // @ts-expect-error -- Vendored Backbone types model events as a function, but Backbone accepts a hash.
      click: 'makeSelection',
    };
  }

  override initialize({collection, sequence}: LinksRowViewOptions): void {
    this.collection = collection;
    this.sequence = sequence;
    // eslint-disable-next-line @typescript-eslint/unbound-method -- Backbone listenTo supplies the receiver.
    this.listenTo(this.sequence.selection(), 'change', this.toggleSelected);
  }

  makeSelection(): void {
    const selection = this.sequence.selection();
    const [primerFwd, primerRev] = Array.from(
      this.model.getPrimers<SequencePrimers, SequencePrimer>(this.collection)
    );
    selection.selectPair(primerFwd, primerRev);
  }

  toggleSelected(): JQuery {
    const [primerFwd, primerRev] = Array.from(
      this.model.getPrimers<SequencePrimers, SequencePrimer>(this.collection)
    );
    const selection = this.sequence.selection();
    const selected =
      selection.getStartState('primer') === primerFwd && selection.getEndState('primer') === primerRev;
    return this.$el.find('tr').toggleClass('active', selected);
  }

  override render(): this {
    const [primerFwd, primerRev] = Array.from(
      this.model.getPrimers<SequencePrimers, SequencePrimer>(this.collection)
    );
    this.$el.html(
      this.template({
        sequence: this.sequence.get('_sequence'),
        primerFwd,
        primerRev,
        productLength: this.model.productLength(
          this.collection,
          this.sequence.circular(),
          this.sequence.length()
        ),
      })
    );
    this.toggleSelected();
    return this;
  }
}
LinksRowView.initClass();

class LinksInformationView extends Backbone.View<never> {
  existingPair: biojs.PrimerPair | null = null;
  panelState!: PrimerPanelState;
  pairs!: biojs.PrimerPairCollection;
  primers!: SequencePrimers;
  selection!: Selection;
  sequence!: Sequence;
  template!: typeof LinksInformationTemplate;

  static initClass(): void {
    this.prototype.template = LinksInformationTemplate;
    this.prototype.events = {
      // @ts-expect-error -- Vendored Backbone types model events as a function, but Backbone accepts a hash.
      'click .unlink-primers': 'destroyPair',
      'click .edit-pair': 'editPair',
      'click .create-sequence': 'createSequence',
      'click .check-secondary': 'checkSecondary',
    };
  }

  destroyPair(): JQueryXHR {
    const pair = this.existingPair!;

    function done(this: LinksInformationView): void {
      notifications.success('Primers successfully unlinked.');
      this.sequence.updateVersions();
      this.render();
      analytics.track('primer', 'unlinked_primers', {
        forward_primer_id: pair.forwardPrimerId(),
        reverse_primer_id: pair.reversePrimerId(),
        sequence_id: this.sequence.get('id'),
      });
    }

    return pair
      .destroy({wait: true})
      .fail(notifications.notifyError) // eslint-disable-next-line no-restricted-syntax
      .done(_.bind(done, this));
  }

  createSequence(): void {
    analytics.track('primer', 'create_sequence', {sequence_id: this.sequence.get('id')});
    this.sequence.handleCreateFromSelectionClick(
      this.sequence.type(),
      this.sequence.type() === SequenceType.SINGLE_STRANDED ? 1 : null
    );
  }

  checkSecondary(): PrimerPanelState {
    const [fwd, rev] = Array.from(
      this.existingPair!.getPrimers<BioJSSequencePrimers, BioJSSequencePrimer>(
        this.sequence.get('_sequence').sequencePrimers()
      )
    );
    EditPrimerTabState.editPair(fwd, rev, this.sequence, true);
    return this.panelState.trigger('close');
  }

  editPair(): PrimerPanelState {
    const [fwd, rev] = Array.from(
      this.existingPair!.getPrimers<BioJSSequencePrimers, BioJSSequencePrimer>(
        this.sequence.get('_sequence').sequencePrimers()
      )
    );
    EditPrimerTabState.editPair(fwd, rev, this.sequence);
    return this.panelState.trigger('close');
  }

  override render(): this {
    this.existingPair = null;
    if (this.selection.canPCR()) {
      let forwardPrimer = this.selection.getStartState('primer')!;
      let reversePrimer = this.selection.getEndState('primer')!;
      assert(
        forwardPrimer.strand() === -reversePrimer.strand(),
        `Primers ${forwardPrimer.name()} and ${reversePrimer.name()} selected and canPCR(), but different strands!`
      );
      // The original JS used this two-assignment "swap" with no temp. reversePrimer is
      // overwritten first, then forwardPrimer is set to that same object, so both names
      // refer to the original start-state primer.
      if (forwardPrimer.strand() === -1) {
        reversePrimer = forwardPrimer;
        forwardPrimer = reversePrimer;
      }
      const forwardTm = forwardPrimer.get('_primer').meltingTemperature();
      const reverseTm = reversePrimer.get('_primer').meltingTemperature();
      const tmDiff = reverseTm - forwardTm;
      const attrs = {primer_fwd_id: forwardPrimer.id, primer_rev_id: reversePrimer.id};

      this.existingPair =
        this.pairs.findWhere(attrs) ||
        new biojs.PrimerPair(attrs, {
          primers: this.primers,
        });
      const productLength = this.existingPair.productLength(
        this.primers,
        this.sequence.circular(),
        this.sequence.length()
      );
      let allowUnlink = true;
      if (this.existingPair != null && !this.sequence.finalized()) {
        const fragmentResult = this.sequence
          .fragmentResults()
          .find((fr) => fr.primerPairID() === this.existingPair!.id);
        allowUnlink = fragmentResult == null;
      }
      if (this.existingPair != null && (forwardPrimer.fromSubPart() || reversePrimer.fromSubPart())) {
        allowUnlink = false;
      }
      this.$el.html(
        this.template({
          forward: {
            name: forwardPrimer.name(),
            tm: forwardTm,
          },
          reverse: {
            name: reversePrimer.name(),
            tm: reverseTm,
          },
          tmDiff: tmDiff > 0 ? `+${tmDiff.toFixed(1)}` : tmDiff.toFixed(1),
          productLength,
          existing: !this.existingPair.isNew(),
          linkable:
            this.existingPair != null &&
            this.sequence.allowFeatureEdits() &&
            !forwardPrimer.fromSubPart() &&
            !reversePrimer.fromSubPart(),
          allowFeatureEdits: this.sequence.allowFeatureEdits(),
          allowUnlink,
        })
      );
      this.$('.link-primers').toggleClass('disabled', !this.existingPair.isNew());
    }
    this.$el.toggleClass('hidden', !this.selection.canPCR());
    this.panelState.trigger('resize');
    return this;
  }

  update(panelState: PrimerPanelState, sequence: Sequence): this {
    this.panelState = panelState;
    this.sequence = sequence;
    this.primers = this.sequence.sequencePrimers();

    if (this.pairs != null) {
      this.stopListening(this.pairs);
    }
    this.pairs = this.sequence.get('_sequence').primerPairs();
    // eslint-disable-next-line @typescript-eslint/unbound-method -- Backbone listenTo supplies the receiver.
    this.listenTo(this.pairs, 'change:id', this.render);

    if (this.selection != null) {
      this.stopListening(this.selection);
    }
    this.selection = this.sequence.selection();
    // eslint-disable-next-line @typescript-eslint/unbound-method -- Backbone listenTo supplies the receiver.
    this.listenTo(this.selection, 'change', this.render);

    return this.render();
  }
}
LinksInformationView.initClass();

class LinksView extends Backbone.View<never> {
  infoView!: LinksInformationView;
  pairs!: biojs.PrimerPairCollection;
  primers!: SequencePrimers;
  rowViews?: Array<LinksRowView>;
  sequence!: Sequence;

  override initialize(): void {
    this.infoView = new LinksInformationView({el: this.$el.find('.link-info')});
  }

  override render(): this {
    let view: LinksRowView;
    if (this.rowViews != null) {
      for (view of Array.from(this.rowViews)) {
        view.remove();
      }
    }
    this.rowViews = Array.from(this.pairs.models).map((pair) =>
      new LinksRowView({
        model: pair,
        collection: this.primers,
        sequence: this.sequence,
      } as LinksRowViewOptions).render()
    );
    const els = (() => {
      const result = [];
      for (view of Array.from(this.rowViews)) {
        result.push(view.el);
      }
      return result;
    })();
    this.$el.find('.primer-links-table').find('tbody').remove();
    if (els.length > 0) {
      this.$el.find('.primer-links-table').append(els);
    } else {
      const $empty = $('<tr>').append($('<td colspan="3">').html('No linked primers attached to sequence'));
      this.$el.find('.primer-links-table').append($('<tbody>').append($empty));
    }
    return this;
  }

  update(panelState: PrimerPanelState, sequence: Sequence): this {
    if (this.primers != null) {
      this.stopListening(this.primers);
    }
    if (this.sequence != null) {
      this.stopListening(this.sequence.get('_sequence'));
    }

    this.sequence = sequence;

    this.primers = sequence.sequencePrimers();

    const listenToPairs = (shouldRender: boolean): void => {
      if (this.pairs != null) {
        this.stopListening(this.pairs);
      }
      this.pairs = sequence.get('_sequence').primerPairs();
      // eslint-disable-next-line @typescript-eslint/unbound-method -- Backbone listenTo supplies the receiver.
      this.listenTo(this.pairs, 'add remove reset', this.render);
      if (shouldRender) {
        this.render();
      }
    };
    this.listenTo(sequence.get('_sequence'), 'change:primerPairs', () => {
      listenToPairs(true);
    });
    listenToPairs(false);

    this.infoView.update(panelState, sequence);
    return this.render();
  }
}

class PrimerPanelView extends InsertBase {
  infoView!: PrimerInfoView;
  linkView!: LinksView;
  pairs!: biojs.PrimerPairCollection;
  primers!: SequencePrimers;
  sequence!: Sequence;

  panelTabsReactRoot: ReactDOM.Root | null = null;
  primerTableReactMount: ReactDOM.Root | null = null;
  toolbarSignupMessageReactMount: ReactDOM.Root | null = null;

  static initClass(): void {
    this.prototype.el = '#primer-panel';
    this.prototype.events = {
      // @ts-expect-error -- Vendored Backbone types model events as a function, but Backbone accepts a hash.
      'click .primers-title': 'showPrimers',
      'click .links-title': 'showLinks',
      'click .create-manual': 'createPrimer',
      'click .create-wizard': 'generatePrimers',
      'click .js-attach-existing': 'searchPrimers',
      'click .link-primers': 'linkPrimers',
      'click .js-detach-all-primers': 'deleteAllPrimers',
      'click .create-primers': 'trackCreatePrimers',
    };
  }

  override initialize(): void {
    this.infoView = new PrimerInfoView({el: this.$el.find('.additional-primer-info')});
    this.linkView = new LinksView({el: this.$el.find('.links-subpanel .panel-container')});
  }

  trackCreatePrimers(): void {
    analytics.track('primer', 'create_primers_clicked', {
      product: ANALYTICS_MODULE.MOLBIO,
      sequence_id: this.sequence.get('id'),
    });
  }

  showSubPanel(): void {
    const panel = this.panelState.get('activeSubPanel');
    this.panelTabsReactRoot = renderPanelTabs(
      this.panelState,
      [
        [
          SEQUENCE_PRIMER_PANEL_PRIMERS,
          `${SEQUENCE_PRIMER_PANEL_PRIMERS}-tab`,
          `${SEQUENCE_PRIMER_PANEL_PRIMERS}-panel`,
          'Primers',
        ],
        [
          SEQUENCE_PRIMER_PANEL_PAIRS,
          `${SEQUENCE_PRIMER_PANEL_PAIRS}-tab`,
          `${SEQUENCE_PRIMER_PANEL_PAIRS}-panel`,
          'Pairs',
        ],
      ],
      this.$('.panel-title')[0],
      this.panelTabsReactRoot
    );
    this.$el.find('h4[class*="-title"]').parent().removeClass('active');
    this.$el.find(`.${panel}-title`).parent().addClass('active');
    this.$el.find('.panel-container').parent().hide();
    this.$el.find(`.${panel}-subpanel`).show();
    this.$el.find('.panel-content').scrollTop(0);
    this.panelState.trigger('resize');
  }

  showPrimers(): PrimerPanelState {
    return this.panelState.set('activeSubPanel', SEQUENCE_PRIMER_PANEL_PRIMERS);
  }

  showLinks(): PrimerPanelState {
    return this.panelState.set('activeSubPanel', SEQUENCE_PRIMER_PANEL_PAIRS);
  }

  createPrimer(e: JQueryEventObject): void {
    e.preventDefault();
    this.insert(new EditPrimerTabState({sequence: this.sequence}));
    analytics.track('primer', 'open_edit_primer_tab', {
      product: ANALYTICS_MODULE.MOLBIO,
      createdFrom: 'toolbar',
      direction: null,
      sequence_id: this.sequence.get('id'),
    });
  }

  generatePrimers(e: JQueryEventObject): void {
    e.preventDefault();
    const tab = new PrimerWizardTabState({
      sequence: this.sequence,
      buffers: this.panelState.get('buffers')!,
    });
    this.insert(tab);
    analytics.track('primer', 'open_primer_wizard', {
      product: ANALYTICS_MODULE.MOLBIO,
      sequence_id: this.sequence.get('id'),
    });
  }

  searchPrimers(): PrimerPanelState {
    analytics.track('primer', 'attach_existing_click', {
      product: ANALYTICS_MODULE.MOLBIO,
      sequence_id: this.sequence.get('id'),
    });
    FindPrimersTabState.insert(this.sequence, {findType: FindPrimersOptions.FOLDERS});
    return this.panelState.trigger('close');
  }

  upsert(tab: TabState): PrimerPanelState {
    const buffers = this.panelState.get('buffers')!;
    const existingTab = buffers.getTab((t) => t.get('title') === tab.get('title'));

    if (existingTab != null) {
      existingTab.set({active: true});
    } else {
      buffers.addTab(tab);
    }
    return this.panelState.trigger('close');
  }

  linkPrimers(): void {
    this.$('.link-primers').button('loading');
    createPrimerPair(this.sequence, () => {
      this.$('.link-primers').button('reset');
      // Must `defer` - https://github.com/twbs/bootstrap/issues/6242
      _.defer(() => this.renderLinkButton());
    });
  }

  async deleteAllPrimers(): Promise<void> {
    if (!this.sequence.allowFeatureEdits()) {
      return;
    }
    if (
      await runConfirmDeleteModal({
        typeName: 'primers',
        message: 'Are you sure you want to remove all primers from the sequence?',
      })
    ) {
      analytics.track('primer', 'deleted_all_primers', {sequence_id: this.sequence.get('id')});
      const primerCollection = this.sequence._primers;
      const [subPartPrimers, nonPartPrimers] = Array.from(
        _.partition(primerCollection.models, (model) => model.fromSubPart())
      );
      const [unsavedPrimers, savedPrimers] = Array.from(
        _.partition(nonPartPrimers, (model) => model.isNew())
      );

      if (subPartPrimers.length && !nonPartPrimers.length) {
        notifications.warn('Primers that belong to sequence parts must be detached from that part.');
        return;
      }
      const deleteSavedPrimers = savedPrimers.length
        ? primerCollection.bulkDelete(savedPrimers, {fileUpdate: true}).fail(notifications.notifyError)
        : null;
      $.when(deleteSavedPrimers).done(() => {
        primerCollection.batchModify(() => {
          primerCollection.remove(unsavedPrimers);
        });
        if (!subPartPrimers.length) {
          notifications.success('All primers detached successfully.');
        } else {
          notifications.success('All non-part primers detached successfully.');
        }
      });
    }
  }

  deleteActivePrimer(): void {
    const activePrimer = this.primers.findWhere({active: true});
    if (activePrimer == null) {
      return;
    }
    let oldIndex = 0;
    for (let i = 0; i < this.primers.models.length; i++) {
      const sequencePrimer = this.primers.models[i];
      if (sequencePrimer.id === activePrimer.id) {
        oldIndex = i;
        break;
      }
    }
    activePrimer
      .destroy()
      .done(() => {
        analytics.track('primer', 'deleted_primer', {sequence_id: this.sequence.get('id')});
        const newIndex = Math.min(oldIndex, this.primers.length - 1);
        if (newIndex >= 0) {
          this.primers.at(newIndex).set({active: true});
        }
        notifications.success(
          <>
            Primer <strong>{activePrimer.name()}</strong> detached successfully.
          </>
        );

        this.renderLibrary();
        this.sequence.updateVersions();
      })
      .fail(notifications.notifyError);
  }

  addLibraryListeners(): void {
    const sequence = this.sequence;
    this.listenTo(
      preferences,
      `change:${PrimerPreferences.MELTING_TEMP_DNA} change:${PrimerPreferences.MELTING_TEMP_RNA}`,
      // eslint-disable-next-line @typescript-eslint/unbound-method -- Backbone listenTo supplies the receiver.
      this.renderLibrary
    );
    // TODO add startindex to synced attrs
    // eslint-disable-next-line @typescript-eslint/unbound-method -- Backbone listenTo supplies the receiver.
    this.listenTo(sequence._sequence(), 'change:startIndex', this.renderLibrary);
  }

  renderLibrary(): void {
    assert(
      this.sequence.sequencePrimers() === this.primers,
      'Primers out of sync with sequence.sequencePrimers'
    );

    const primerProps = getPrimerTableProps(this.sequence);
    this.primerTableReactMount = renderToDOM(
      <PrimerTable {...primerProps} />,
      this.$el.find('.primers-table-container').get(0),
      this.primerTableReactMount
    );

    this.$('.js-detach-all-primers-section').toggleClass('hidden', !this.primers.length);
  }

  renderLinkButton(): JQuery {
    return this.$('.link-primers').toggleClass('disabled', !canCreatePrimerPair(this.sequence));
  }

  _updateListener<K extends 'panelState' | 'sequence' | 'primers' | 'pairs'>(
    reference: K,
    replacement: this[K]
  ): void {
    const current = this[reference];
    if (current != null) {
      this.stopListening(current);
    }
    this[reference] = replacement;
  }

  override render(): this {
    this.showSubPanel();

    this.renderLibrary();
    this.addLibraryListeners();

    this.renderLinkButton();
    this.$('.js-disable-readonly .btn').toggleClass('disabled', !this.sequence.allowFeatureEdits());

    if (showValueMessagingForSharedFile()) {
      this.$('.js-hide-for-share-link').addClass('hide');

      this.toolbarSignupMessageReactMount = renderToDOM(
        <ToolbarSignupMessage action="add a primer" />,
        this.$el.find('.share-link-message-react-mount')[0],
        this.toolbarSignupMessageReactMount
      );
    } else if (!this.sequence.allowFeatureEdits()) {
      this.$('.js-disable-readonly').tooltip({
        title: 'Enabled on writable sequences only',
        placement: 'bottom',
        container: 'body',
      });
      this.$('.js-detach-all-primers').addClass('disabled');
    } else {
      this.$('.js-disable-readonly').tooltip('destroy');
    }
    this.$('.link-primers').toggleClass('hidden', !this.sequence.allowFeatureEdits());

    return this;
  }

  update(panelState: PrimerPanelState, sequence: Sequence, _fileState?: unknown): this {
    this._updateListener('panelState', panelState);
    // eslint-disable-next-line @typescript-eslint/unbound-method -- Backbone listenTo supplies the receiver.
    this.listenTo(this.panelState, 'change:activeSubPanel', this.showSubPanel);
    // eslint-disable-next-line @typescript-eslint/unbound-method -- Backbone listenTo supplies the receiver.
    this.listenTo(this.panelState, 'deleteActive', this.deleteActivePrimer);
    this._updateListener('sequence', sequence);
    this._updateListener('primers', sequence.sequencePrimers());
    this._updateListener('pairs', sequence.primerPairs());
    // eslint-disable-next-line @typescript-eslint/unbound-method -- Backbone listenTo supplies the receiver.
    this.listenTo(this.primers, 'change remove add reset saved', this.render);
    this.listenTo(
      this.primers,
      'change:strand change:nucleotideType change:fromSubPart change:selected',
      // eslint-disable-next-line @typescript-eslint/unbound-method -- Backbone listenTo supplies the receiver.
      this.renderLinkButton
    );
    // eslint-disable-next-line @typescript-eslint/unbound-method -- Backbone listenTo supplies the receiver.
    this.listenTo(this.pairs, 'remove add reset saved', this.renderLinkButton);

    this.infoView.update(panelState, sequence);
    this.linkView.update(panelState, sequence);

    this.$('.js-detach-all-primers').toggleClass('disabled', !this.sequence.get('_sequence').finalized());
    return this.render();
  }

  override remove(): this {
    unmountRootsAsync(
      [this.panelTabsReactRoot, this.primerTableReactMount, this.toolbarSignupMessageReactMount],
      () => {
        this.panelTabsReactRoot = null;
        this.primerTableReactMount = null;
        this.toolbarSignupMessageReactMount = null;
        super.remove();
      }
    );
    return this;
  }
}
PrimerPanelView.initClass();

export default PrimerPanelView;
